declare namespace $ {

	type $mol_view__sub_bog_ui_app_divider_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_app_divider extends $mol_page {
		description( ): string
		Description( ): $mol_view
		Divider( ): $bog_ui_divider
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=divider.view.tree.d.ts.map